<template>
  <div class="modal notification-modal" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);">
    <div class="modal-dialog-centered modal-base">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">[공지] {{props.data.title}}</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
            <div class="notification-content" style="overflow-x:auto;">
              <tiptapTextEditor ref="textEditor" :modCond="false"/>
            </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="$emit('close')">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import axios from "@/composables/Axios";
import tachoEntity from "@/entity/TachoEntity";
import Entity from "@/entity/OperationEntity";
import {tiptapTextEditor} from "@/components/tacho/component/index";
import {
  changeFormat
} from '@/components/tacho/common/CommonFunc';

const props = defineProps({
  data: Object,
})

const textEditor = ref();
const emit = defineEmits(['close']);

onMounted(async () => {
  textEditor.value.setEditable(false);
  textEditor.value.setText(props.data.content);
})
</script>

<style>
.notification-content .text-editor .tiptap.ProseMirror {
  border: none;
  padding: 0;
  height: auto;
}
</style>
